module.exports = __webpack_public_path__ + "img/20400.0130f97a.jpg";